function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M10.156 20.313a10.157 10.157 0 1110.156-10.157 10.168 10.168 0 01-10.156 10.156zm0-18.75a8.594 8.594 0 108.594 8.593 8.603 8.603 0 00-8.594-8.594zm4.096 9.242L10.737 6.9a.78.78 0 00-1.161 0L6.06 10.806a.781.781 0 001.161 1.045l2.935-3.261 2.935 3.26a.782.782 0 101.162-1.044z",
  fill: "#B4C0CF"
});

var SvgBespokenIconExpanded = function SvgBespokenIconExpanded(props) {
  return React.createElement("svg", _extends({
    width: 21,
    height: 21,
    fill: "none"
  }, props), _ref);
};

export default SvgBespokenIconExpanded;